import * as angular from 'angular';
import { config, reactShell } from 'angular/utils/config';

type Data = {
    _links?: {
        [key: string]: {
            href: string;
        };
    };
};

export class CapacityManagementService {
    public accessible = false;

    private resolveData;
    public data = new Promise<Data | null>(
        (resolve) => (this.resolveData = resolve)
    );

    constructor() {
        this.init();
    }

    private async init() {
        if (!config.capacityManagement) {
            this.resolveData(null);
            return;
        }

        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);
            const response = await reactShell.axios.request({
                url: config.capacityManagement,
                signal: controller.signal
            });
            clearTimeout(timeoutId);

            this.resolveData(response.data);
            this.accessible = Boolean(response.data._links);
        } catch (e) {
            this.resolveData(null);

            if (
                e &&
                e.name === 'AxiosError' &&
                e.response &&
                (e.response.status === 401 || e.response.status === 403)
            )
                return;
            console.error(e);
        }
    }
}

angular.module('app').service('camaService', CapacityManagementService);
